module.exports = __webpack_public_path__ + "fonts/StdKaiXHYL6EG-Md.ttf";